export default __webpack_public_path__ + "static/portfolio-368fcfed121ff39057eb22b224efd711.png";